import { baseTheme } from './base';

export const themes = {
  base: baseTheme,
};
